module.exports = __webpack_public_path__ + "static/media/oee_dashboard.03e1c43f.svg";